<template>
    <sa-page-layout :btnSaveVisible="btnSaveVisible" :btnAnnullaVisible="true" :linkback="linkback" :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space">
        <!-- <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickSalva">
                <b-icon icon="check"> </b-icon>
                Nuovo
            </b-button>
        </template> -->
        <template slot="table-body">
            <magazzino-articoli-edit-component @updateJsonData="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" ref="cmpMagazzinoArticoliEdit" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import MagazzinoArticoliEditComponent from "../components/MagazzinoArticoliEditComponent.vue";
export default {
    name: "MagazzinoArticoliEditPage",
    components: { SaPageLayout, MagazzinoArticoliEditComponent },
    data() {
        return {
            btnSaveVisible: true,
            showModalLoading: false,
            linkback: "/magazzino/articoli",
            pathResource: "/magazzinoarticoli",
            jsonData: null,
        };
    },
    methods: {
        onUpdateJsonData(jsonData) {
            this.jsonData = jsonData;
        },
        /* onClickSalva() {
            let me = this;
            me.$refs.cmpMagazzinoArticoliEdit.onSalvaAnagraficaArticolo();
        }, */
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
